import { h, Fragment, } from "preact";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box } from "@mui/material";
import Item2 from "./Item2";


const SortableGridItem = (props) => {
    //console.log("SortableGridItem", props)
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id: props.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    return (
        <Box >
            <Item2
                props={props}
                ref={setNodeRef}
                style={style}
                {...attributes}
                {...listeners}

            ></Item2>
        </Box>

    );
};

export default SortableGridItem;